import { HttpServiceBase } from './http-service-base';

export class DecisionService extends HttpServiceBase {
  get(applicationId) {
    return new Promise((resolve, reject) => {
      this.http.get(`v1/decisions?applicationId=${applicationId}`)
        .then(message => JSON.parse(message.response))
        .then(decision => resolve(decision))
        .catch(e => reject(e));
    });
  }

  // downloadPdf saves the applicant's locked decision as a PDF. fallbackName
  // is used when the response has no file name.
  async downloadPdf(applicationId, fallbackName) {
    const { blob, filename } = await this.http.getBlob(`/v2/decisions/${applicationId}/applicant-pdf`);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Give the browser time to finish reading the blob into the download.
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
}
